module.exports = __webpack_public_path__ + "static/federation_logo2-a8435f467abf5e7b177010993ea43e16.png";